
function StoreMyTicketStatus() {
    return [
      { statusID: 101, statusName: "New" },
      { statusID: 102, statusName: "Open" },
      { statusID: 103, statusName: "Resolved" }
    ];
  }
  export default StoreMyTicketStatus;